
import Wrapper from './styles';

export default {
  name: 'NotificationBadge',
  components: {
    Wrapper,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
};
